import React from "react";

export default function Loader() {
  return (
    <div id="preloader">
      <div className="spinner-grow text-purple" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
